import React from "react";

export default function Marquee({ items, className = "" }) {
  const list = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee gap-12 whitespace-nowrap">
        {list.map((it, i) => (
          <span key={i} className="flex items-center gap-12 font-serif text-4xl md:text-5xl italic text-bone/90">
            {it}
            <span className="text-amber not-italic">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
